import axios from '../utilities/axios'

async function getCountry() {
  return axios.get('/api/v1/geo/country')
}

async function getCountryLanguage(countryCode) {
  return axios.get(`/api/v1/geo/country/language?code=${countryCode}`)
}

export default {
  getCountry,
  getCountryLanguage,
}
